export default {
  common: {
    nav: {
      home: "Ana Sayfa",
      find_offer_help: "Yardım Bul / Sun",
      celebrate: "Bir Hayatı Anmak",
      family_tree: "Aile Ağacı",
      events: "Etkinlikler",
      civic_reports: "Sivil Raporlar",
      neighborhood_pulse: "Mahalle Nabzı",
      weather: "Hava Durumu",
      nature: "Doğa",
      marketplace: "Pazar",
      news: "Haberler",
      causes: "Amaçlar",
      more: "Daha Fazla",
    },
    header: { sign_in: "Giriş Yap", join: "Social Pulse'a Katıl", language: "Dil", search: "Ara" },
    tagline: "Toplulukları Bağlamak · Hayatları Güçlendirmek · Sosyal Sermaye İnşa Etmek",
    locality: { viewing_from: "Şuradan görüntülüyorsunuz", change: "Değiştir", set_your_location: "Konumunuzu ayarlayın" },
    news: { title: "Günlük özetiniz.", play_briefing: "Günlük özeti dinle", listen: "Dinle", translate: "Çevir" },
  },
};
